export default __webpack_public_path__ + "./images/mc.28792816.png";